// extracted by mini-css-extract-plugin
export default {"userButton":"HeaderUser_userButton__PYobF","userPhoto":"HeaderUser_userPhoto__hYQrQ","userName":"HeaderUser_userName__KJvaV"};